import { createContext, useContext } from 'react';

interface CrieSeuRoteiroContextType {
  data: FormCreateJourneyDataPageType;
}

const CrieSeuRoteiroContext = createContext<CrieSeuRoteiroContextType>({} as CrieSeuRoteiroContextType);

export const useCrieSeuRoteiroContext = () => {
  return useContext(CrieSeuRoteiroContext);
};

export default CrieSeuRoteiroContext;
